(function initLegalPageSmoothScroll() {
  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return value.replace(/["\\]/g, '\\$&');
  }

  function getScrollTarget(hashValue) {
    if (!hashValue) return null;

    var normalized = hashValue.charAt(0) === '#' ? hashValue.slice(1) : hashValue;
    if (!normalized) return null;

    var escaped = cssEscape(normalized);

    return document.getElementById(normalized)
      || document.querySelector('[id="#' + escaped + '"]')
      || document.querySelector('[name="' + escaped + '"]');
  }

  function bindSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.lpSmoothScrollBound === 'true') return;

    sectionRoot.dataset.lpSmoothScrollBound = 'true';

    sectionRoot.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a[href^="#"]') : null;
      if (!link || !sectionRoot.contains(link)) return;

      var href = link.getAttribute('href') || '';
      if (href.length <= 1) return;

      var target = getScrollTarget(href);
      if (!target) return;

      event.preventDefault();

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', href);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.legal-page').forEach(function (sectionRoot) {
      bindSection(sectionRoot);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event && event.target;
    if (!target) return;

    var sectionRoot = target.matches && target.matches('.legal-page')
      ? target
      : target.querySelector && target.querySelector('.legal-page');

    if (sectionRoot) bindSection(sectionRoot);
  });
})();
